module.exports = __webpack_public_path__ + "img/googlewide.2668709d.png";